export default __webpack_public_path__ + "static/hero-banner-5513e316c66dcba052095dc9b791c305.jpg";